// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"_2-5-O77-0UCEWyqVCEJ2vF","form":"K89Yqfa8cVeP0tU7ZzGkX"};